import React from 'react';
import { computationDecimalScale, computationValueLength } from '../../../../common/helper';
import FormsyInputField from '../../../elements/FormsyInputField';
import FormFields from "../../formFields/computation.json";
const IF_SETTLEMENT_BOX = FormFields?.IF_SETTLEMENT_BOX;

const IfSettlementBox = ({
    handlePatternFormatChange,
    computationDetails,
    allfieldsReadonly,
    isRegeneratedFieldActive,
    financierId,
    lead,
    handleRadioChange,
    handleInputChange,
}) => {
    return <section className='loan-detail-filed-bg'>
        <h2>IF Settlement Box</h2>
{IF_SETTLEMENT_BOX.map((field) => {

    // condition 1
    if (field.id === "is_if_transfer_to_finsso" && computationDetails?.is_if_case !== "Yes") {
        return null;
    }

    if (["total_amount_sent_to_finsso","from_main_dealer","from_split_payments"].includes(field.name) && computationDetails?.is_if_transfer_to_finsso !== "Yes") {
        return null;
    }

    return (
        (["text", "number-format"].includes(field.type) && (
            <fieldset className="form-filed col-md-6 ">
                                <FormsyInputField
                                    id={field.id}
                                    name={field.name}
                                    type={field.type}
                                    value={computationDetails?.[field.name]}
                                    placeholder=" "
                                    {...(field.type === "number-format") ? {
                                        thousandsGroupStyle: "thousand",
                                        thousandSeparator: ',',
                                        decimalSeparator: '.'
                                    } : {}}
                                    label={field.label}
                                    onChange={field.type === "number-format"
                                        ? (data) => handlePatternFormatChange(data, field.name)
                                        : handleInputChange}
                                    format={field.ApplyNumberformat ? field.format : ""}
                                    validations={field.validations}
                                    validationError={computationDetails?.[field.name] ? field.validationError : ""}
                                    readOnly={field.readOnly || allfieldsReadonly}
                                    required={field.required}
                                    decimalScale={computationDecimalScale(financierId)}
                                    valueLength={computationValueLength(financierId)} />
                                    <div>
                                        {field.name === "from_main_dealer" && (
                                            <>Total Payment - Rp {computationDetails?.final_loan_value}</>
                                        )}

                                        {field.name === "from_split_payments" && (
                                            <>Total Payment - Rp {computationDetails?.dealer_incentive_net_of_tax}</>
                                        )}
                                    </div>
                            </fieldset>
            
        ))
        ||
        (field.type === "radio" && (
            <fieldset className="form-filed col-md-12 radio-btn radio-type-txt" key={field.id}>
                <label className="form-label">{field.label}</label>

                {field.options.map((option) => (
                    <div className="custom-control custom-checkbox" key={option.value}>
                        <input
                            id={option.value}
                            type="radio"
                            className="custom-control-input"
                            name={option.name}
                            value={option.value}
                            checked={option.value === computationDetails?.[option.name]}
                            defaultChecked={option.value === lead?.leadDetail?.lead_computation_details?.[option.name]}
                            onChange={handleRadioChange}
                            disabled={
                                allfieldsReadonly ||
                                (computationDetails?.adp_type === "Yes") 
                            }
                        />
                        <label htmlFor={option.value} className="custom-control-label">
                            {option.label}
                        </label>
                    </div>
                ))}
            </fieldset>
        ))
    );
})}
    </section>;
};


export default IfSettlementBox;

